"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const useFramerRefWorkaround_1 = require("../../hooks/useFramerRefWorkaround");
const Col = (props) => {
    const { sm, md, lg, xl, xs = 12, offsets = {} } = props;
    const sizes = { sm, md, lg, xl, xs };
    const usesHiddenSize = Object.values(sizes).find((size) => size === 0) === 0;
    const classes = {
        hidden: usesHiddenSize,
    };
    Object.keys(sizes)
        .forEach((breakpoint) => {
        // xs is used as default.
        if (breakpoint === 'xs') {
            return;
        }
        const size = sizes[breakpoint];
        if (size !== 0 && size !== undefined) {
            // default to sm, so no media query.
            const mediaPrefix = `${breakpoint}:`;
            classes[`${mediaPrefix}col-span-${size}`] = true;
            classes[`${mediaPrefix}block`] = usesHiddenSize;
        }
    });
    Object.keys(offsets).forEach((breakpoint) => {
        classes[`${breakpoint}:col-start-${offsets[breakpoint]}`] = true;
    });
    const primitiveProps = helpers_1.usePrimitiveProps(props, { className: classnames_1.default(`col-span-${xs}`, classes) });
    const framerRefWorkaround = useFramerRefWorkaround_1.useFramerRefWorkaround(primitiveProps);
    return (react_1.default.createElement(framer_motion_1.motion.div, Object.assign({}, primitiveProps, { ref: framerRefWorkaround })));
};
exports.default = withJourney_1.default('j-col', Col);
